import React, {useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    withStyles,
    TextField, Chip
} from '@material-ui/core';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { hasPermission } from '../../../sc-utilities';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const ChangeGroupModal = props => {
    const { classes, modalState, handleCloseDanger, handleCloseSafe, translations, groups, defaultValue, permissions=[] } = props;

    const [group, setGroup] = useState(defaultValue);

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    return (
        <Dialog
            open={modalState.open}
            onClose={handleCloseSafe}
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle>{translations['change_group'] || 'Change group'}</DialogTitle>
            <DialogContent>
                <Autocomplete
                    name="GroupID"
                    id="GroupID"
                    options={hasAccessAllGroupsPermission? [{GroupID: null, Name: translations['none'] || "None"}, ...groups || []] || [] : groups || []}
                    getOptionLabel={(option) => option.Name || ""}
                    getOptionSelected={(option, value) => option.GroupID === value.GroupID}
                    filterSelectedOptions
                    disableClearable
                    value={group || ""}
                    onChange={(_, value) => { setGroup(value) }}
                    renderInput={(params) => (
                        <TextField {...params} variant="standard" fullWidth={true} label={`${translations["please_select_group"] || "Please select group"}`} />
                    )}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip label={option.Name} {...getTagProps({ index })} />
                        ))
                    }
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['cancel'] || 'Cancel'}
                </Button>
                <Button disabled={!group} onClick={() => handleCloseDanger(group?.GroupID)} variant="contained" className={classes.buttonDanger}>
                    {translations['save'] || 'SAVE'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(ChangeGroupModal);